import Reveal from '../common/Reveal';
import './Footer.css';

const COLUMNS = [
  {
    heading: 'Protocol',
    links: ['Overview', 'Whitepaper', 'Security audits', 'Roadmap'],
  },
  {
    heading: 'Developers',
    links: ['Docs', 'SDK', 'Testnet faucet', 'GitHub'],
  },
  {
    heading: 'Network',
    links: ['Explorer', 'Validators', 'Governance', 'Status'],
  },
  {
    heading: 'Company',
    links: ['About', 'Careers', 'Blog', 'Contact'],
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <Reveal as="up" className="footer__brand">
            <a
              href="https://coti.io/"
              target="_blank"
              rel="noopener noreferrer"
              className="site-header__logo footer__logo"
            >
              <img src="/logo-mark.svg" className="site-header__logo-mark" alt="" aria-hidden="true" />
              COTI
            </a>
            <p>The encrypted compute layer for Web3.</p>
          </Reveal>

          <div className="footer__columns">
            {COLUMNS.map((col, i) => (
              <Reveal as="up" delay={0.05 * i} key={col.heading}>
                <div className="footer__column">
                  <h4>{col.heading}</h4>
                  <ul>
                    {col.links.map((link) => (
                      <li key={link}>
                        <a href="https://coti.io/" target="_blank" rel="noopener noreferrer">
                          {link}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="footer__bottom">
          <span>© {new Date().getFullYear()} COTI Labs. All rights reserved.</span>
          <div className="footer__legal">
            <a href="https://coti.io/" target="_blank" rel="noopener noreferrer">
              Privacy policy
            </a>
            <a href="https://coti.io/" target="_blank" rel="noopener noreferrer">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}